export default __webpack_public_path__ + "static/media/ConfidentialScreensDarkResponsiveSmall.9b676c34.png";